/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

export interface MapLayerIconProps extends IconProps {
  // crosses the icon out, while every map layer is turned off ...
  noLayers?: boolean;
}

/*
 * Defines the Design Language System (DLS) Map Layer Icon component - crossed
 * out (`noLayers`) while every map layer is turned off, as the legacy icon is.
 */
export const MapLayerIcon = ({noLayers = false, ...props}: MapLayerIconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M20.583 8.77353C20.8049 8.97452 20.8017 9.32417 20.576 9.52096L12.3349 16.7079C12.1439 16.8745 11.8585 16.8718 11.6706 16.7017L3.41699 9.22647C3.19507 9.02548 3.19835 8.67583 3.424 8.47904L11.6651 1.29207C11.8561 1.1255 12.1415 1.12817 12.3294 1.2983L20.583 8.77353Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M17.7911 12.0535L20.5935 14.6363C20.8111 14.8369 20.8079 15.1815 20.5866 15.3779L12.3382 22.6998C12.1462 22.8703 11.8563 22.8676 11.6674 22.6936L3.4065 15.0822C3.18889 14.8817 3.19204 14.5371 3.41329 14.3406L6.04889 12' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      {noLayers && (
        <path d='M1 23.4697L23.6274 0.842309' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      )}
    </svg>
  );
};

export default MapLayerIcon;
